export default __webpack_public_path__ + "static/8_26-f7df04458d438c5611337a762f449281.png";